import type { ResumeSectionType } from '@applicator/shared'

import { getResumeSectionEmptyHintMessage } from '../../utils/resumeSectionEmptyHint'

type ResumeSectionEmptyHintProps = {
  sectionType: ResumeSectionType
  className?: string
}

export default function ResumeSectionEmptyHint({
  sectionType,
  className = '',
}: ResumeSectionEmptyHintProps) {
  const message = getResumeSectionEmptyHintMessage(sectionType)
  if (!message) return null

  return (
    <div
      className={`text-sm text-text-muted ${className}`.trim()}
      data-testid={`section-empty-hint-${sectionType}`}
    >
      {message}
    </div>
  )
}
